



















import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Button from '../Button.vue';
import Config from '../../utils/Config';
import { MESSAGE_TYPE } from '../../vo/ChatMessageData';
import SockController, { SOCK_ACTIONS } from '../../controller/SockController';

@Component({
	components:{
		Button
	}
})
export default class ConstToAngles extends Vue {

	public constellation:string = "aquila";
	public va:number = 1;
	public vb:number = 1;

	public get constList():string[] {
		return Config.CONSTELLATION_LIST.sort();
	}

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

	public submit():void {
		let data = {
			type:MESSAGE_TYPE.CONST_TO_ANGLES,
			a:this.va,
			b:this.vb,
			constellation:this.constellation,
			from:this.$store.state.me.id,
		}
		SockController.instance.sendMessage({action:SOCK_ACTIONS.SEND_MESSAGE, includeSelf:true, data});
	}

}
